//Libraries
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../core/services';

@Injectable()
export class PasswordService {
    private passwordUrl = '/password';
    private passwordResetUrl = '/password-resets';
    private apiUrl = '';

    constructor (
        private settingService: SettingService,
        private apiService: ApiService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    /**
     * Call API service to request for a reset password email.
     * @param {string} role - role of the user.
     * @param {string} email - email to send the reset password.
     * @returns {Observable<any>} - Status code 202: Accepted.
     */
    sendResetPasswordEmail(role:string, email: string): Observable<any> {
        const requestUrl = this.apiUrl + this.passwordResetUrl;
        const body = JSON.stringify({
                        'role': role,
                        'email': email
                     });
        
        return this.apiService.post(requestUrl, body);
    }
    /**
     * Call API service to verify the token sent in the reset password email.
     * @param {string} token - token string.
     * @returns {Observable<any>}
     *  - Status code 200: OK
     *  - Status code 404: Not Found or Expired
     */
    verifyPasswordResetToken(token: string): Observable<any> {
        const requestUrl = this.apiUrl + this.passwordResetUrl + "/" + token;

        return this.apiService.get(requestUrl);
    }   

    /**
     * Call API service to set new password with the token sent in the reset
     * password email.
     * @param {string} token
     * @param {string} password
     * @returns {Observable<any>}
     *  - Status code 204: Password Assigned
     *  - Status code 404: Not Found or Expired 
     */
    setPasswordWithResetToken(token: string, password: string): Observable<any> {
        const requestUrl = this.apiUrl + this.passwordResetUrl + "/" + token;
        // TODO: update body content
        const body = JSON.stringify({password});

        return this.apiService.patch(requestUrl, body);
    }

    /**
     * Call API service to request for new password update.
     * @param {string} oldPassword - old password input
     * @param {string} newPassword - new password input
     * @returns {Observable<any>}
     *  - Status code 204: Password Changed
     *  - Status code 401: Unauthorized or Incorrect Password
     */
    setNewPassword(oldPassword: string, newPassword: string): Observable<any> {
        const requestUrl = this.apiUrl + this.passwordUrl;
        const body = JSON.stringify({
                        'old':  oldPassword,
                        'new':  newPassword
                     });
        
        return this.apiService.post(requestUrl, body);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/services/PasswordService.ts